"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.govDistributor14 = exports.govDistributor13 = exports.govDistributor12 = exports.govDistributor11 = exports.govDistributor10 = exports.govDistributor9 = exports.govDistributor8 = exports.govDistributor7 = void 0;
const govDistributor7 = {
    appId: 1073098885,
};
exports.govDistributor7 = govDistributor7;
const govDistributor8 = {
    appId: 1136393919,
};
exports.govDistributor8 = govDistributor8;
const govDistributor9 = {
    appId: 1200551652,
};
exports.govDistributor9 = govDistributor9;
const govDistributor10 = {
    appId: 1282254855,
};
exports.govDistributor10 = govDistributor10;
const govDistributor11 = {
    appId: 1702641473,
};
exports.govDistributor11 = govDistributor11;
const govDistributor12 = {
    appId: 2057814942,
};
exports.govDistributor12 = govDistributor12;
const govDistributor13 = {
    appId: 2330032485,
};
exports.govDistributor13 = govDistributor13;
const govDistributor14 = {
    appId: 2629511242,
};
exports.govDistributor14 = govDistributor14;
//# sourceMappingURL=mainnet-constants.js.map